import isEmpty from 'lodash/isEmpty';
import Image from 'src/components/image';
import { APP_IMG } from 'src/constants';
// import styled from 'styled-components';

export const getFeatureImage = (_data: any, _showImg = false) => {
  if (isEmpty(_data)) return null;
  if (_showImg) {
    return (
      <Image
        image={_data?.image}
        title={_data?.title}
        ignoreLazy={false}
        // type={'FEATURE_IMAGE'}
        type='FEATURE_IMAGE'
      />
    );
  }
  switch (_data?.type_video) {
    case '0':
      return (
        <div className='embed-responsive embed-responsive-16by9'>
          <iframe src={`${`${APP_IMG}/${_data?.video_src}`}?autoplay=1`} />
        </div>
      );
    case '1': // dailymotion
      return (
        <div
          className='embed-responsive'
          dangerouslySetInnerHTML={{
            __html: `
              <script
              type='text/javascript'
              src='https://geo.dailymotion.com/player/${_data?.video_src}.js'
              data-video=${_data?.video_src}
              ></script>`
          }}
        />
      );
    case '2': // youtube url
      return (
        <div className='embed-responsive embed-responsive-16by9'>
          <iframe src={`${_data?.video_src}?autoplay=1`} />
        </div>
      );
    case '5': // youtube url
      return <div dangerouslySetInnerHTML={{ __html: `${_data?.video_src}` }} />;

    default:
      return (
        <Image
          image={_data?.image}
          title={_data?.title}
          ignoreLazy={false}
          priority={true}
          // type={'FEATURE_IMAGE'}
          type='FEATURE_IMAGE'
        />
      );
  }
};

// const EmbdedWrapper = styled.div`
//   position: absolute;
//   display: block;
//   width: 100%;
//   top: 0;
//   overflow: hidden;
//   .embed-dailymotion {
//     iframe {
//       width: 100%;
//       height: 480px;
//       @media (max-width: 500px) {
//         height: 220px;
//       }
//     }
//   }
// `;
